var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _DuoyunDateRangePanelElement_onSelect, _DuoyunDateRangePanelElement_onDateHover;
import { adoptedStyle, customElement, globalemitter, property } from '@mantou/gem/lib/decorators';
import { GemElement, html } from '@mantou/gem/lib/element';
import { createCSSSheet, css } from '@mantou/gem/lib/utils';
import { Time, parseNarrowRelativeTime, parseNarrowTimeRange } from '../lib/time';
import { theme } from '../lib/theme';
import { isNullish } from '../lib/types';
import './date-panel';
import './button';
import './action-text';
import './divider';
const style = createCSSSheet(css `
  :host {
    display: flex;
    align-items: flex-start;
  }
  .datepanel {
    width: 100%;
    flex-shrink: 1;
    border: none;
  }
  .separate {
    color: ${theme.lightBackgroundColor};
    margin-inline: 0.5em;
  }
`);
/**
 * @customElement dy-date-range-panel
 */
let DuoyunDateRangePanelElement = class DuoyunDateRangePanelElement extends GemElement {
    constructor() {
        super();
        this.state = {};
        _DuoyunDateRangePanelElement_onSelect.set(this, (evt) => {
            evt.stopPropagation();
            const { start, stop } = this.state;
            if (isNullish(start) || (!isNullish(start) && !isNullish(stop))) {
                this.setState({ start: evt.detail, stop: undefined });
            }
            else {
                this.setState({ stop: evt.detail });
                this.change([Math.min(start, evt.detail), Math.max(start, evt.detail)]);
            }
        });
        _DuoyunDateRangePanelElement_onDateHover.set(this, ({ detail }) => {
            this.setState({ hover: detail });
        });
        this.willMount = () => {
            this.memo(() => {
                if (Array.isArray(this.value)) {
                    return this.setState({ start: this.value[0], stop: this.value[1] });
                }
                if (typeof this.value === 'string') {
                    const parsed = parseNarrowRelativeTime(this.value);
                    if (parsed) {
                        return this.setState({ start: parsed.startOf('d').valueOf(), stop: new Time().valueOf() });
                    }
                    const range = parseNarrowTimeRange(this.value);
                    if (range) {
                        return this.setState({ start: range[0].startOf('d').valueOf(), stop: range[1].valueOf() });
                    }
                }
            }, () => [this.value]);
        };
        this.render = () => {
            const { start, stop, hover } = this.state;
            const highlightStop = stop || hover;
            const highlights = !isNullish(start) && highlightStop ? [[Math.min(start, highlightStop), Math.max(start, highlightStop)]] : [];
            const isSomeMonth = !isNullish(start) && !isNullish(stop) && new Time(start).isSome(stop, 'M');
            return html `
      <dy-date-panel
        class="datepanel"
        @change=${__classPrivateFieldGet(this, _DuoyunDateRangePanelElement_onSelect, "f")}
        @datehover=${__classPrivateFieldGet(this, _DuoyunDateRangePanelElement_onDateHover, "f")}
        .value=${start}
        .highlights=${highlights}
        .initValue=${isNullish(start)
                ? new Time().subtract(1, 'M').valueOf()
                : isSomeMonth
                    ? new Time(start).subtract(1, 'M').valueOf()
                    : undefined}
      ></dy-date-panel>
      <dy-divider class="separate" orientation="vertical"></dy-divider>
      <dy-date-panel
        class="datepanel"
        @change=${__classPrivateFieldGet(this, _DuoyunDateRangePanelElement_onSelect, "f")}
        @datehover=${__classPrivateFieldGet(this, _DuoyunDateRangePanelElement_onDateHover, "f")}
        .value=${stop}
        .highlights=${highlights}
        .initValue=${isSomeMonth ? start : undefined}
      ></dy-date-panel>
    `;
        };
        this.internals.role = 'widget';
    }
};
_DuoyunDateRangePanelElement_onSelect = new WeakMap(), _DuoyunDateRangePanelElement_onDateHover = new WeakMap();
__decorate([
    property
], DuoyunDateRangePanelElement.prototype, "value", void 0);
__decorate([
    globalemitter
], DuoyunDateRangePanelElement.prototype, "change", void 0);
DuoyunDateRangePanelElement = __decorate([
    customElement('dy-date-range-panel'),
    adoptedStyle(style)
], DuoyunDateRangePanelElement);
export { DuoyunDateRangePanelElement };
//# sourceMappingURL=date-range-panel.js.map